import { Add } from '@mui/icons-material';
import {
    Box, Typography, styled,
    Button,
} from '@mui/material';
import { SetCard } from './SetCard';

const StyledContainer = styled(Box)(({ theme }) => ({
    padding: theme.spacing(3),
    height: '100%',
    overflow: 'auto',
}));

interface SetsWidgetsContainerProps {
    config: Models.SetsPlayground.SetsConfig | null;
    onSetPriorityChange: (index: number, priority: number) => void;
    onAddSet: () => void;
    onDeleteSet: (index: number) => void;
    onSetNameChange: (index: number, name: string) => void;
    onSetDistributionChange: (index: number, dist: Models.SetsPlayground.SetDistribution) => void;
    onSetRankingChange: (index: number, ranking: Models.SetsPlayground.SetRanking) => void;
    onSetFilterChange: (index: number, filter: Models.SetsPlayground.SetFilterRequest) => void;
    onSetDesignPersonalizationContextIdChange: (index: number, id: string) => void;
    productKey?: string;
    onSetProductKeyChange?: (key: string) => void;
}

export const SetsWidgetsContainer = ({
    config,
    onSetPriorityChange,
    onAddSet,
    onDeleteSet,
    onSetNameChange,
    onSetDistributionChange,
    onSetRankingChange,
    onSetFilterChange,
    onSetDesignPersonalizationContextIdChange,
    productKey,
    onSetProductKeyChange,
}: SetsWidgetsContainerProps): JSX.Element => {
    const indexed = config ? config.sets.map((s, i) => ({ origIndex: i, set: s })) : [];
    const sorted = [...indexed].sort((a, b) => a.set.priority - b.set.priority);
    const totalSets = indexed.length;

    return (
        <StyledContainer>
            <Box alignItems="center" display="flex" gap={2} justifyContent="flex-end" mb={2}>
                {totalSets === 0 && (
                    <Typography color="text.secondary" variant="body1">
                        No sets configured. Add a set to see the widget controls here.
                    </Typography>
                )}
                <Button startIcon={<Add />} variant="contained" onClick={onAddSet}>
                    Add Set
                </Button>
            </Box>
            {totalSets > 0 && sorted.map(({ origIndex, set }, displayIdx) => (
                <SetCard
                    displayIndex={displayIdx}
                    index={origIndex}
                    key={origIndex}
                    productKey={productKey}
                    set={set}
                    onChangeDesignPersonalizationContextId={onSetDesignPersonalizationContextIdChange}
                    onChangeDistribution={onSetDistributionChange}
                    onChangeFilter={onSetFilterChange}
                    onChangeName={onSetNameChange}
                    onChangePriority={onSetPriorityChange}
                    onChangeProductKey={onSetProductKeyChange}
                    onChangeRanking={onSetRankingChange}
                    onDelete={onDeleteSet}
                />
            ))}
        </StyledContainer>
    );
};
